import {theme} from "./Tema";
import dolares from "./Recursos/dolares.png";
import resort from "./Recursos/resort.png";
import iphone from "./Recursos/iphone.png";
import mac from "./Recursos/mackbook.png";
import moto from "./Recursos/moto.png";
import reloj from "./Recursos/reloj.png";
import carro from "./Recursos/carro.png";


//export const NUMEROWASS = '3004627579'

export const NUMEROWASS = '3128911448'

export const FONDOCARD = {
    borderRadius: 1,
    border: 0.5,
    borderColor: '#ffffff50',
    background: 'linear-gradient(151deg, rgba(255, 255, 255, 0.10) 6.5%, rgba(45, 45, 45, 0.10) 59.48%)',
    backdropFilter: 'blur(5px)',
    color: '#fff',
}

export const URLBILLETERA = 'https://usuario.bitnovaworld.com/'

export const URLPAGINA = 'https://bitnovaworld.com/'

export const TIEMPOACTIVACIONCONTRATO = 1000 * 60 * 60 * 24 * 2

export const CRYPTOS = [
    {
        nombre: 'USDT RED (TRC20)',
        key: 'TXLxsE1oQN4EW9P8mosvpnx2GbyoG2hVkv',

    },{
        nombre: 'LTC RED (LITECOIN)',
        key: 'ltc1qz5tm8ae7w6psnxk7nel5l9mmx7w56ulgu0u6rv',

    }
]


export const ESTADOSUSUARIOS = [
    {
        nombre: 'Solicitante',
        color: theme.palette.primary.main
    },
    {
        nombre: 'Admin',
        color: theme.palette.secondary.main
    },
    {
        nombre: 'Suspendido',
        color: theme.palette.info.main
    },
]

export const ESTADOHISTORIAL= [
    {
        nombre: 'Aceptado',
        color: theme.palette.primary.main
    },
    {
        nombre: 'Validando',
        color: '#ffffff'
    },
    {
        nombre: 'Rechazado',
        color: '#bf0000'
    },
]

export const ESTADOSSOPORTE = [
    {
        nombre: 'Abierto',
        color: theme.palette.primary.main
    },
    {
        nombre: 'Cerrado',
        color: theme.palette.secondary.main
    },
    {
        nombre: 'Contactando',
        color: theme.palette.info.main
    },
]

export const TIPOSMOVIMIENTOS = [
    {
        nombre: 'Deposito'
    }
]


export const TIPOSRETIRO = [
    {
        nombre: 'Premium',
        descripcion: 'Comisión del 14%, con procesamiento entre 16 a 32 horas.',
        corta: '(Premium) comision 14%',
        porcentaje: 14
    },
    {
        nombre: 'Standard',
        descripcion: 'Comisión del 10%, con procesamiento entre 24 a 72 horas.',
        corta: '(Standard) comision 10%',
        porcentaje: 10
    },
]

export const metasUno = [
    {
        nombre: '$50 USD',
        valor: 1000,
        descripcion: 'Directamente en bonos libres',
        tiempo: 'de 24 a 48 horas',
        img: dolares,
        dinero: true
    },
    {
        nombre: '$150 USD',
        valor: 3000,
        descripcion: 'Directamente en bonos libres',
        tiempo: 'de 24 a 48 horas',
        img: dolares,
        dinero: true
    },
    {
        nombre: '$350 USD',
        valor: 7500,
        descripcion: 'Directamente en bonos libres',
        tiempo: 'de 24 a 48 horas',
        img: dolares,
        dinero: true
    }

]

export const metasDos = [
    {
        nombre: 'Resort de Lujo',
        valor: 10000,
        descripcion: 'Resort de lujo 3 días 2 noches en pareja',
        tiempo: 'de 4 a 12 semanas',
        img: resort
    },
    {
        nombre: 'Iphone 17 Pro Max',
        valor: 20000,
        descripcion: 'Iphone 17 Pro Max 512Gb',
        tiempo: 'de 2 a 4 semanas',
        img: iphone,

    },
    {
        nombre: 'Mac Book + Apple Watch',
        valor: 40000,
        descripcion: 'Mac Book Air M2 + Apple Watch Ultima Serie',
        tiempo: 'de 2 a 4 semanas',
        img: mac
    },
    {
        nombre: 'Yz Yamaha 125',
        valor: 100000,
        descripcion: 'Internacion, peles y tramite de placas',
        tiempo: 'de 4 a 8 semanas',
        img: moto
    },

]

export const metasTres = [
    {
        nombre: 'Reloj Rolex',
        valor: 150000,
        descripcion: 'Reloj Rolex Oyster Perpetual Rolex Deepsea',
        tiempo: 'de 4 a 8 semanas',
        img: reloj
    },
    {
        nombre: 'Mercedes Benz Cla 180 AMG',
        valor: 300000,
        descripcion: 'Internacion, peles y tramite de placas',
        tiempo: 'de 4 a 8 semanas',
        img: carro
    }

]

export const todos = [...metasUno, ...metasDos, ...metasTres];